import { toast } from '../hooks/use-toast';

function getErrorMessage(error: any, entityName?: string) {
  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  const responseMessage = error?.response?.data?.message;
  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage;
  }

  const directMessage = error?.message;
  if (typeof directMessage === 'string' && directMessage.trim()) {
    return directMessage;
  }

  return entityName ? 'Неуспешна операција за ' + entityName : 'Настана грешка';
}

export function showSuccess(title: string, description?: string) {
  toast({ title, description });
}

export function showError(error: any, entityName?: string) {
  toast({
    title: 'Грешка',
    description: getErrorMessage(error, entityName),
    variant: 'destructive',
  });
}
